import React from "react";

import { useSizeClass } from "../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorRouteProp,
} from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WARegular } from "./WARegular";
import { WACompact } from "./WACompact";
import { WidgetSizeT } from "../localTypes/WidgetSizeT";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { SafeAreaProvider } from "react-native-safe-area-context";

type Props = {
  navigation: UserLoggedInNavigatorNavigationProp<"WidgetAdd">;
  route: UserLoggedInNavigatorRouteProp<"WidgetAdd">;
};

export const WidgetAdd = withWebModal(WidgetAddC, true);
function WidgetAddC(props: Props) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const w = props.route.params.position.w;
  const h = props.route.params.position.h;

  return (
    <SafeAreaProvider>
      {isCompact ? (
        <WACompact
          maxSize={{ w, h } as WidgetSizeT}
          defaultTeams={props.route.params.defaultTeams}
          onClose={props.navigation.goBack}
          storecastId={props.route.params.storecastId}
          position={props.route.params.position}
        />
      ) : (
        <WARegular
          maxSize={{ w, h } as WidgetSizeT}
          defaultTeams={props.route.params.defaultTeams}
          onClose={props.navigation.goBack}
          storecastId={props.route.params.storecastId}
          position={props.route.params.position}
        />
      )}
    </SafeAreaProvider>
  );
}
